import { extractLanguageFromPath } from "@Utils/languageCore";
import { REGIONAL_BLOG_LANG_VALUES } from "locales/langConfig/langConfig";

export type RegionalBlogLanguage = (typeof REGIONAL_BLOG_LANG_VALUES)[number];

export const isRegionalBlogLanguage = (lang?: string | null): lang is RegionalBlogLanguage =>
  !!lang && REGIONAL_BLOG_LANG_VALUES.includes(lang);

export const getBlogLanguageFromPath = (path: string): RegionalBlogLanguage | undefined => {
  const lang = extractLanguageFromPath(path);
  return lang && isRegionalBlogLanguage(lang) ? lang : undefined;
};
